import React from 'react';
import styles from './PaginationWrapper.module.scss';

import clsx from 'clsx';

export function PaginationWrapper({ isAllSelected, children }) {
  return <div className={clsx(styles.pagination, isAllSelected && styles.fixed)}>{children}</div>;
}
